module.exports = __webpack_public_path__ + "media/images/emblems/Flumenthal-blason-e9ca5f69e9410085625d1bbb4a711e58.png";